export const ISO_DATE_ONLY = 'YYYY-MM-DD';
export const ISO_WITHOUT_TIMEZONE = 'YYYY-MM-DD[T]HH:mm:ss';
export const DASHBOARD_DATE = 'DD.MM.YYYY HH:mm';
